import SDIcon from './SDIcon'

const IconCarbonLifebuoy = (props) => (
  <SDIcon title='Lifebuoy' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16,2C8.268,2,2,8.268,2,16s6.268,14,14,14s14-6.268,14-14S23.732,2,16,2z M16,4c2.61,0,5.02,0.84,6.99,2.26l-3.54,3.54C18.38,9.29,17.22,9,16,9s-2.38,0.29-3.45,0.8L9.01,6.26C10.98,4.84,13.39,4,16,4z M4,16c0-2.61,0.84-5.02,2.26-6.99l3.54,3.54C9.29,13.62,9,14.78,9,16s0.29,2.38,0.8,3.45l-3.54,3.54C4.84,21.02,4,18.61,4,16z M16,28c-2.61,0-5.02-0.84-6.99-2.26l3.54-3.54C13.62,22.71,14.78,23,16,23s2.38-0.29,3.45-0.8l3.54,3.54C21.02,27.16,18.61,28,16,28z M16,21c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S18.76,21,16,21z M25.74,22.99l-3.54-3.54C22.71,18.38,23,17.22,23,16s-0.29-2.38-0.8-3.45l3.54-3.54C27.16,10.98,28,13.39,28,16S27.16,21.02,25.74,22.99z'
      fill='currentColor'
    />
  </SDIcon>
)

export default IconCarbonLifebuoy
